import React from 'react';
import { Mic, Volume2 } from 'lucide-react';

const DeviceSelector = ({
    audioDevices,
    selectedDevices,
    onMicrophoneChange,
    onSpeakerChange
}) => {
    const getDeviceLabel = (device) => {
        if (!device.label) return `Device ${device.deviceId.slice(0, 8)}`;
        // Show if it's Bluetooth
        const label = device.label;
        if (label.toLowerCase().includes('bluetooth')) {
            return `🔵 ${label}`;
        }
        return label;
    };

    return (
        <div className="space-y-3 w-full">
            {/* Microphone Selector */}
            <div>
                <label className="text-xs text-gray-600 mb-1 flex items-center gap-1">
                    <Mic size={12} />
                    Microphone
                </label>
                <select
                    value={selectedDevices.microphone}
                    onChange={(e) => onMicrophoneChange(e.target.value)}
                    className="w-full px-3 py-2 bg-gray-100 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primarycolor"
                >
                    <option value="default">Default Microphone</option>
                    {audioDevices.microphones.map((device) => (
                        <option key={device.deviceId} value={device.deviceId}>
                            {getDeviceLabel(device)}
                        </option>
                    ))}
                </select>
            </div>

            {/* Speaker Selector */}
            <div>
                <label className="text-xs text-gray-600 mb-1 flex items-center gap-1">
                    <Volume2 size={12} />
                    Speaker
                </label>
                <select
                    value={selectedDevices.speaker}
                    onChange={(e) => onSpeakerChange(e.target.value)}
                    className="w-full px-3 py-2 bg-gray-100 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primarycolor"
                >
                    <option value="default">Default Speaker</option>
                    {audioDevices.speakers.map((device) => (
                        <option key={device.deviceId} value={device.deviceId}>
                            {getDeviceLabel(device)}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default DeviceSelector;